module.exports = __webpack_public_path__ + "img/cops.png";